module.exports = __webpack_public_path__ + "img/sounds-on.853aa177.jpg";